import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=0b23679b&scoped=true&"
import script from "./SummaryList.vue?vue&type=script&lang=js&"
export * from "./SummaryList.vue?vue&type=script&lang=js&"
import style0 from "./SummaryList.vue?vue&type=style&index=0&id=0b23679b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23679b",
  null
  
)

export default component.exports